/* eslint-disable */

import * as React from 'react';

interface IProps {
    className?: string;
}

class RatingStars extends React.Component<IProps> {
    state = { clipPathUrlId: Math.floor(Math.random() * 100000000) + 1 };

    public render() {
        return (
            <svg
                width="152"
                height="26"
                viewBox="0 0 152 26"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className={this.props.className}>
                <path
                    d="M11.8634 0.861746L8.63493 7.36383L1.33371 8.39048C0.0423422 8.58603 -0.454339 10.1504 0.489355 11.0793L5.70451 16.1148L4.4628 23.2035C4.26413 24.4746 5.65484 25.4523 6.79721 24.8657L13.3037 21.4924L19.7606 24.8657C20.903 25.4523 22.2937 24.4746 22.095 23.2035L20.8533 16.1148L26.0684 11.0793C27.0121 10.1504 26.5154 8.58603 25.2241 8.39048L17.9725 7.36383L14.6944 0.861746C14.1481 -0.262675 12.4594 -0.311563 11.8634 0.861746Z"
                    fill="#039BE5"
                />
                <path
                    d="M42.9739 0.861746L39.7455 7.36383L32.4443 8.39048C31.1529 8.58603 30.6563 10.1504 31.6 11.0793L36.8151 16.1148L35.5734 23.2035C35.3747 24.4746 36.7654 25.4523 37.9078 24.8657L44.4143 21.4924L50.8712 24.8657C52.0135 25.4523 53.4043 24.4746 53.2056 23.2035L51.9639 16.1148L57.179 11.0793C58.1227 10.1504 57.626 8.58603 56.3347 8.39048L49.0831 7.36383L45.805 0.861746C45.2587 -0.262675 43.57 -0.311563 42.9739 0.861746Z"
                    fill="#039BE5"
                />
                <path
                    d="M74.0845 0.861746L70.8561 7.36383L63.5549 8.39048C62.2635 8.58603 61.7669 10.1504 62.7105 11.0793L67.9257 16.1148L66.684 23.2035C66.4853 24.4746 67.876 25.4523 69.0184 24.8657L75.5249 21.4924L81.9818 24.8657C83.1241 25.4523 84.5149 24.4746 84.3162 23.2035L83.0745 16.1148L88.2896 11.0793C89.2333 10.1504 88.7366 8.58603 87.4453 8.39048L80.1937 7.36383L76.9156 0.861746C76.3693 -0.262675 74.6806 -0.311563 74.0845 0.861746Z"
                    fill="#039BE5"
                />
                <path
                    d="M105.195 0.861746L101.966 7.36383L94.6653 8.39048C93.3739 8.58603 92.8772 10.1504 93.8209 11.0793L99.0361 16.1148L97.7943 23.2035C97.5957 24.4746 98.9864 25.4523 100.129 24.8657L106.635 21.4924L113.092 24.8657C114.234 25.4523 115.625 24.4746 115.427 23.2035L114.185 16.1148L119.4 11.0793C120.344 10.1504 119.847 8.58603 118.556 8.39048L111.304 7.36383L108.026 0.861746C107.48 -0.262675 105.791 -0.311563 105.195 0.861746Z"
                    fill="#039BE5"
                />
                <path
                    d="M136.305 0.861746L133.077 7.36383L125.776 8.39048C124.484 8.58603 123.988 10.1504 124.931 11.0793L130.147 16.1148L128.905 23.2035C128.706 24.4746 130.097 25.4523 131.239 24.8657L137.746 21.4924L144.203 24.8657C145.345 25.4523 146.736 24.4746 146.537 23.2035L145.295 16.1148L150.511 11.0793C151.454 10.1504 150.958 8.58603 149.666 8.39048L142.415 7.36383L139.137 0.861746C138.59 -0.262675 136.902 -0.311563 136.305 0.861746Z"
                    fill="#039BE5"
                />
                <g clipPath={`url(#clip0_1162_${this.state.clipPathUrlId})`}>
                    <path
                        d="M136.305 0.861746L133.077 7.36383L125.775 8.39048C124.484 8.58603 123.987 10.1504 124.931 11.0793L130.146 16.1148L128.904 23.2035C128.706 24.4746 130.096 25.4523 131.239 24.8657L137.745 21.4924L144.202 24.8657C145.345 25.4523 146.735 24.4746 146.537 23.2035L145.295 16.1148L150.51 11.0793C151.454 10.1504 150.957 8.58603 149.666 8.39048L142.414 7.36383L139.136 0.861746C138.59 -0.262675 136.901 -0.311563 136.305 0.861746Z"
                        fill="#153755"
                    />
                </g>
                <defs>
                    <clipPath id={`clip0_1162_${this.state.clipPathUrlId}`}>
                        <rect width="13.6583" height="25.0402" fill="white" transform="translate(138.1)" />
                    </clipPath>
                </defs>
            </svg>
        );
    }
}

export default RatingStars;
